// usePreferencesStore.ts
import { create } from 'zustand';
import { dayjs } from '@digiwedge/date-ranges';
import { createJSONStorage, persist } from 'zustand/middleware';
import { DEFAULT_LOCATION_OPTION } from '../utils/location-buckets.js';
export const usePreferencesStore = create()(persist((set) => ({
    preferences: {
        timeOfDay: 'all',
        numberOfHoles: 18,
        players: 1,
        location: DEFAULT_LOCATION_OPTION,
        date: dayjs().toISOString(),
        earliestTime: '06:00',
        latestTime: '18:00',
        minPriceCents: 0,
        maxPriceCents: 0,
        leadTimeDays: 0,
        searchQuery: '',
        favoritesOnly: false,
    },
    setPreferences: (preferences) => set({ preferences }),
    updatePreference: (key, value) => set((state) => ({
        preferences: { ...state.preferences, [key]: value },
    })),
}), {
    name: 'preferences-storage',
    storage: typeof window === 'undefined' ? undefined : createJSONStorage(() => localStorage),
    merge: (persistedState, currentState) => {
        const state = persistedState;
        return {
            ...currentState,
            ...state,
            preferences: {
                ...currentState.preferences,
                ...state.preferences,
            },
        };
    },
}));
//# sourceMappingURL=usePreferenceStore.web.js.map